import { useMutation } from '@tanstack/react-query';
import { useGetCurrentBoardId } from 'entities/user/api/hooks/useGetCurrentBoardId';
import { handleBatchTask } from 'shared/api/batches';
import { postPdfs } from '../requests';
import type { PostPdfsRequestType } from '../types';

export type UsePostPdfs2MutationParams = {
  boardId?: number;
};

type MutationFnParams = Omit<PostPdfsRequestType, 'boardId'> & {
  boardId?: number;
};

export const usePostPdfs2 = (params?: UsePostPdfs2MutationParams) => {
  const currentBoardId = useGetCurrentBoardId();
  const boardId = params?.boardId || currentBoardId;

  return useMutation({
    mutationFn: (param: MutationFnParams) =>
      handleBatchTask(
        postPdfs({
          boardId: boardId as number,
          ...param,
        }),
      ),
  });
};
